export default "__VITE_ASSET__Dkw4AMJe__"